import dc from "../assets/images/dc.png";
import marvel from "../assets/images/marvel.png";
import star from "../assets/images/star.png";
import wb from "../assets/images/wb.png";
import focus from "../assets/images/pixer.png";

const Franchises = () => {
  return (
    <div className="bg-gray-900 sm:h-[45vh]">
      <div className=" pt-6">
        <h1 className="text-gray-400 text-xl sm:text-2xl font-bold tracking-wider text-center py-3">
          Franchise Partner
        </h1>
      </div>

      <div className="px-3 sm:sm:w-[90%] sm:ml-auto space-y-5 sm:space-y-0  sm:mr-auto sm:flex sm:justify-between sm:items-center mt-5">
        <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
          <img className="h-32 object-contain" src={dc} alt="" />
        </div>
        <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
          <img className="h-32 object-contain" src={marvel} alt="" />
        </div>
        <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
          <img className="h-32 object-contain" src={star} alt="" />
        </div>
        <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
          <img className="h-32 object-contain" src={focus} alt="" />
        </div>
        <div className="px-3 py-3 bg-gray-800 shadow-lg border border-gray-700 rounded-sm hover:bg-gray-700 hover:border-gray-400 flex justify-center">
          <img className="h-32 object-contain" src={wb} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Franchises;
